import { Action } from "redux"
import { ISearch, ISmartSearchInitData, ISuggestion } from "./index"

export const INITIALIZE = "SEARCH_INITIALIZE"
export const SET_INITIALIZED = "SEARCH_SET_INITIALIZED"
export const SET_CUSTOM_FIELD_SUGGEST_FIELDS =
    "SEARCH_SET_CUSTOM_FIELD_SUGGEST_FIELDS"
export const REQUEST_SEARCH = "SEARCH_REQUEST_SEARCH"
export const RECEIVE_SEARCH_RESULTS = "SEARCH_RECEIVE_SEARCH_RESULTS"
export const UPDATE_VISIBILITY = "SEARCH_UPDATE_VISIBILITY"

export interface Initialize extends Action {
    workspaceId: number
    smartSearchInitData?: ISmartSearchInitData
}

export interface InitializeSmartSearch extends Action {
    props: Partial<ISearch>
}

export interface SetCustomFieldSuggestFields extends Action {
    customFieldSuggestFields: string[]
}

export interface RequestSearch extends Action {
    searchString: string
}

export interface RequestSuggestions extends Action {
    searchString: string
}

export interface ReceiveSearchResults extends Action {
    searchResultsUrl: string
}

export interface ReceiveSuggestions extends Action {
    suggestions: ISuggestion[]
}

export interface UpdateVisibility extends Action {
    visibility: boolean
}

export const initializeSearch = (
    workspaceId: number,
    smartSearchInitData?: ISmartSearchInitData,
): Initialize => ({ type: INITIALIZE, smartSearchInitData, workspaceId })

export const setInitialized = (): Action => ({ type: SET_INITIALIZED })

export const setCustomFieldSuggestFields = (
    customFieldSuggestFields: string[],
): SetCustomFieldSuggestFields => ({
    type: SET_CUSTOM_FIELD_SUGGEST_FIELDS,
    customFieldSuggestFields,
})

export const requestSearch = (searchString: string): RequestSearch => ({
    type: REQUEST_SEARCH,
    searchString,
})

export const receiveSearchResults = (
    searchResultsUrl: string,
): ReceiveSearchResults => ({ type: RECEIVE_SEARCH_RESULTS, searchResultsUrl })

export const updateVisibility = (visibility: boolean): UpdateVisibility => ({
    type: UPDATE_VISIBILITY,
    visibility,
})

export const mapDispatchToProps = {
    requestSearch,
    setCustomFieldSuggestFields,
    updateVisibility,
}

export type DispatchProps = typeof mapDispatchToProps
